import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateOfferListUseCase {
    invoke: (itemId: number, data: any) => Promise<boolean>;
}
export class UpdateOfferList implements UpdateOfferListUseCase {
private Repo: OffersPromoRepository;
constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
}

async invoke(itemId: number, data: any){
    
    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
            );
    }  
    const update  = await this.Repo.updateOfferList(itemId, data);
    return update;
}
}